module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper add-redirect",
    on: {
      "click": _vm.addNewRedirect
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Создать редирект\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "redirects"
  }, _vm._l((_vm.redirectsData), function(redirect) {
    return _c('RedirectItem', {
      key: redirect.id,
      attrs: {
        "redirect": redirect
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49937530"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Redirects/Index.vue
// module id = 943
// module chunks = 0